import { defaultProps } from 'recompose';

import { svg, defaultWidgetConfig } from 'constants';

import CommonButton from './CommonButton';

export default defaultProps({
  tooltipText: 'Administration Tools',
  icon: svg.adminTools,
  widget: defaultWidgetConfig,
})(CommonButton);
